export default {
  LOGIN: "登陸",
  SIGNUP: "註冊",
  FORGOT_PASSWORD: "忘記密碼？",
  OR_LOGIN_WITH_EMAIL: "或者您可以使用",
  LOGIN_WITH: "使用",
  OR_SIGNUP_WITH_EMAIL: "或者您可以使用電子郵件註冊",
  EMAIL_FOR_RESET_PASSWORD: "請登陸您的郵箱驗證。",
  AUTHENTICATION_TYPE_SUBTITLE: "选择用户注册和登录时使用的标识符。",
  SIGNING_KEYS_LEVEL: "層級",
  SIGNING_KEYS_TENANT: "租戶",
  SIGNING_KEYS_OAUTH: "OAuth"
};
